function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetupAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-37",
    d: "M96.11,434.09c85.82,42.11,225,42.11,310.77,0s85.81-110.4,0-152.51-224.95-42.12-310.77,0S10.29,392,96.11,434.09Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-37"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-37",
    cx: 144.11,
    cy: 406.32,
    rx: 46.7,
    ry: 22.26,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-37",
    cx: 379.01,
    cy: 340.84,
    rx: 46.7,
    ry: 22.26,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.76,245l-39.61,22.87a7.45,7.45,0,0,0-3.19,4.56l-9.84,56.83a4.74,4.74,0,0,0,2.14,4.57l25.54,14.74a5.87,5.87,0,0,0,5.32,0l54.58-31.51a5,5,0,0,0,0-8.84l-19.64-11.34a6.73,6.73,0,0,1-3-4.59l-4.37-42.88a6.52,6.52,0,0,0-2.81-4.5A5.7,5.7,0,0,0,201.76,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.46,338.59v10.63a5.51,5.51,0,0,0,2.66-.64l54.58-31.51a5.71,5.71,0,0,0,2.66-4.42,5.2,5.2,0,0,0-1.05-2.88h-8.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.75,247.9l-39.61,22.86a7.43,7.43,0,0,0-3.18,4.57L155,326.91a4.73,4.73,0,0,0,2.14,4.57l19.64,11.34a5.93,5.93,0,0,0,5.32,0L236.7,311.3c1.47-.85,1.47-2.22,0-3.07l-19.64-11.34a6.73,6.73,0,0,1-3-4.59l-4.37-42.88A1.84,1.84,0,0,0,206.75,247.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.7,308.23l-19.64-11.34a6.25,6.25,0,0,1-1.95-1.95L155.4,329.42a4.46,4.46,0,0,0,1.76,2.06l19.64,11.34a5.93,5.93,0,0,0,5.32,0L236.7,311.3C238.17,310.45,238.17,309.08,236.7,308.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.89,358l-2.53-1.46a8.24,8.24,0,0,1-3.73-6.46V180a8.21,8.21,0,0,1,3.73-6.44l207.8-119.3a8.25,8.25,0,0,1,7.45,0l1.94,1.12a8.2,8.2,0,0,1,3.72,6.45V232a8.23,8.23,0,0,1-3.72,6.45L83.34,358A8.22,8.22,0,0,1,75.89,358Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.61,184.38l-13.88-8a7.59,7.59,0,0,0-1.1,3.67V350.12a8.24,8.24,0,0,0,3.73,6.46L75.89,358a8.22,8.22,0,0,0,7.45,0l1.27-.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.62,355.89V185.8a8.24,8.24,0,0,1,3.72-6.45L290.55,59.72c2.06-1.19,3.72-.23,3.72,2.15V232a8.23,8.23,0,0,1-3.72,6.45L83.34,358C81.29,359.23,79.62,358.26,79.62,355.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,292.49l19.63-11.34c1.47-.85,2.67-.24,2.67,1.35a5.72,5.72,0,0,1-2.67,4.42l-19.63,11.33c-1.47.85-2.66.25-2.66-1.34A5.71,5.71,0,0,1,176.92,292.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.16,184.55l195.15-113c1.17-.68,2.12-.14,2.12,1.22V221a4.71,4.71,0,0,1-2.12,3.69L89.17,337.38c-1.18.68-2.13.13-2.13-1.22V188.24A4.71,4.71,0,0,1,89.16,184.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.44,187.39,275.48,84c3.25-1.87,5.91-.34,5.91,3.41V216.16a6.08,6.08,0,0,1-2.74,4.75L95.38,326.7c-1.51.88-2.74.16-2.74-1.58V194A8.44,8.44,0,0,1,96.44,187.39Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.85 164.91 268.52 107.94 268.52 127.76 169.85 184.72 169.85 164.91",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.85 192.57 268.52 135.6 268.52 185.24 169.85 242.21 169.85 192.57",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.39,90.53V87.44c0-3.75-2.66-5.28-5.91-3.41l-179,103.36a8.44,8.44,0,0,0-3.8,6.59v5.51Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.61,97.55a4.51,4.51,0,0,0-2,3.53c0,1.3.91,1.82,2,1.17a4.48,4.48,0,0,0,2-3.52C258.65,97.43,257.74,96.91,256.61,97.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.69,92.89a4.49,4.49,0,0,0-2,3.53c0,1.29.91,1.82,2,1.17a4.51,4.51,0,0,0,2-3.52C266.72,92.77,265.81,92.24,264.69,92.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.76,88.23a4.51,4.51,0,0,0-2,3.52c0,1.3.91,1.83,2,1.18a4.49,4.49,0,0,0,2-3.53C274.8,88.11,273.89,87.58,272.76,88.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,270a1.07,1.07,0,0,1-.52-.14,1.05,1.05,0,0,1-.53-.91v-64.4a1,1,0,0,1,.52-.91l55.68-32.26a1.08,1.08,0,0,1,1.06,0,1.06,1.06,0,0,1,.53.92v64.45a1.05,1.05,0,0,1-.53.91l-55.68,32.2A1.08,1.08,0,0,1,101.21,270Zm1.06-64.84v62l53.57-31v-62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,246.75a11,11,0,0,1-5.56-1.44c-4-2.31-6.21-7.09-6.21-13.48,0-12.68,8.92-28.18,19.89-34.53,5.51-3.19,10.75-3.68,14.75-1.37s6.21,7.09,6.21,13.48c0,12.7-8.93,28.19-19.9,34.54A18.63,18.63,0,0,1,120.4,246.75Zm17.31-50.14a16.49,16.49,0,0,0-8.13,2.52c-10.39,6-18.84,20.69-18.84,32.7,0,5.6,1.83,9.74,5.15,11.65s7.81,1.43,12.63-1.36c10.39-6,18.85-20.68,18.85-32.71,0-5.6-1.83-9.74-5.16-11.65A8.87,8.87,0,0,0,137.71,196.61Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.52,278.63l-3.87-2.24h0a.64.64,0,0,0-.6,0l-7,3.15a.83.83,0,0,1-1.16-.54,15.75,15.75,0,0,0-1.56-3.47,1.9,1.9,0,0,1-.11-1.69l4.66-9.4a1.06,1.06,0,0,0-.41-1.37l-5.06-2.92a1,1,0,0,0-1.39.32l-5.81,8.74a2,2,0,0,1-1.52.76,14,14,0,0,0-2,.09v-6.39l-3.89-2.24h0a.64.64,0,0,0-.63.06l-7.86,4.54a2.13,2.13,0,0,0-.94,1.46l-.78,8.75a2.89,2.89,0,0,1-.82,1.63,48.06,48.06,0,0,0-4.37,4.62,1.49,1.49,0,0,1-1.54.44l-5.05-1.76a1.23,1.23,0,0,0-1.41.52l-5.78,10a1.23,1.23,0,0,0,.25,1.49l4.05,3.49a1.5,1.5,0,0,1,.39,1.56,46.38,46.38,0,0,0-1.81,6.09,2.93,2.93,0,0,1-1,1.52l-7.18,5.05a2.15,2.15,0,0,0-.8,1.55v9.07a.65.65,0,0,0,.28.59h0l3.87,2.23,5.75-2.72a14.19,14.19,0,0,0,.71,1.34,1.9,1.9,0,0,1,.11,1.69l-4.66,9.4a1.06,1.06,0,0,0,.41,1.37l5.06,2.92a1.06,1.06,0,0,0,1.39-.32l5.81-8.74a2,2,0,0,1,1.52-.76,15.78,15.78,0,0,0,3.79-.38.83.83,0,0,1,1.05.74l.76,7.63a.66.66,0,0,0,.31.54h0l3.87,2.23,4.64-6.82a2.13,2.13,0,0,0,.94-1.47l.78-8.74a1.76,1.76,0,0,1,1-1.32,18.51,18.51,0,0,0,6.1-4.29,1.61,1.61,0,0,1,1.57-.41l3.1,1.09a1.22,1.22,0,0,0,1.41-.53l5.78-10a1.23,1.23,0,0,0-.25-1.49l-2.66-2.3a1.62,1.62,0,0,1-.44-1.57,26.09,26.09,0,0,0,.73-7.25,2,2,0,0,1,.75-1.54l7.18-5.06a2.12,2.12,0,0,0,.8-1.54l3.43-4.11Zm-34.32,36c-7.33,4.24-11.89,1.23-11.89-7.23s6.06-18.84,13.39-23.07,11.78-1.16,11.78,7.31S312.53,310.36,305.2,314.59Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.52,278.63l-3.87-2.24h0a.64.64,0,0,0-.6,0l-7,3.15a.83.83,0,0,1-1.16-.54,15.75,15.75,0,0,0-1.56-3.47,1.9,1.9,0,0,1-.11-1.69l4.66-9.4a1.06,1.06,0,0,0-.41-1.37l-5.06-2.92a1,1,0,0,0-1.39.32l-5.81,8.74a2,2,0,0,1-1.52.76,14,14,0,0,0-2,.09v-6.39l-3.89-2.24h0a.64.64,0,0,0-.63.06l-7.86,4.54a2.13,2.13,0,0,0-.94,1.46l-.78,8.75a2.89,2.89,0,0,1-.82,1.63,48.06,48.06,0,0,0-4.37,4.62,1.49,1.49,0,0,1-1.54.44l-5.05-1.76a1.23,1.23,0,0,0-1.41.52l-5.78,10a1.23,1.23,0,0,0,.25,1.49l4.05,3.49a1.5,1.5,0,0,1,.39,1.56,46.38,46.38,0,0,0-1.81,6.09,2.93,2.93,0,0,1-1,1.52l-7.18,5.05a2.15,2.15,0,0,0-.8,1.55v9.07a.65.65,0,0,0,.28.59h0l3.87,2.23,5.75-2.72a14.19,14.19,0,0,0,.71,1.34,1.9,1.9,0,0,1,.11,1.69l-4.66,9.4a1.06,1.06,0,0,0,.41,1.37l5.06,2.92a1.06,1.06,0,0,0,1.39-.32l5.81-8.74a2,2,0,0,1,1.52-.76,15.78,15.78,0,0,0,3.79-.38.83.83,0,0,1,1.05.74l.76,7.63a.66.66,0,0,0,.31.54h0l3.87,2.23,4.64-6.82a2.13,2.13,0,0,0,.94-1.47l.78-8.74a1.76,1.76,0,0,1,1-1.32,18.51,18.51,0,0,0,6.1-4.29,1.61,1.61,0,0,1,1.57-.41l3.1,1.09a1.22,1.22,0,0,0,1.41-.53l5.78-10a1.23,1.23,0,0,0-.25-1.49l-2.66-2.3a1.62,1.62,0,0,1-.44-1.57,26.09,26.09,0,0,0,.73-7.25,2,2,0,0,1,.75-1.54l7.18-5.06a2.12,2.12,0,0,0,.8-1.54l3.43-4.11Zm-34.32,36c-7.33,4.24-11.89,1.23-11.89-7.23s6.06-18.84,13.39-23.07,11.78-1.16,11.78,7.31S312.53,310.36,305.2,314.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.33,267.57l1.54-3.11a1.06,1.06,0,0,0-.41-1.37l-5.06-2.92a1,1,0,0,0-1.39.32l-5.81,8.74a1.72,1.72,0,0,1-.39.37l6.5,3.76Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,305.28a2.24,2.24,0,0,1-.55.59l-7.18,5.05a1.82,1.82,0,0,0-.47.55l4.38,2.53,9.53-5.43Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.37,281.13a1.23,1.23,0,0,0-1,.58l-5.78,10a1.23,1.23,0,0,0-.13.73l5,2.88,7.91-10.7Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.49,267l6.16,3.56,7-4v-2.82l-3.89-2.24h0a.64.64,0,0,0-.63.06l-7.86,4.54A2.09,2.09,0,0,0,300.49,267Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.52,278.63h0a.64.64,0,0,0-.62,0l-7,3.16a.83.83,0,0,1-1.16-.54,15.06,15.06,0,0,0-1-2.46L335,276.4a.68.68,0,0,1,.61,0h0Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.33,267.57l1.54-3.11a1.06,1.06,0,0,0-.41-1.37l-5.06-2.92a1,1,0,0,0-1.39.32l-5.81,8.74a1.72,1.72,0,0,1-.39.37l6.5,3.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,305.28a2.24,2.24,0,0,1-.55.59l-7.18,5.05a1.82,1.82,0,0,0-.47.55l4.38,2.53,9.53-5.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.37,281.13a1.23,1.23,0,0,0-1,.58l-5.78,10a1.23,1.23,0,0,0-.13.73l5,2.88,7.91-10.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.49,267l6.16,3.56,7-4v-2.82l-3.89-2.24h0a.64.64,0,0,0-.63.06l-7.86,4.54A2.09,2.09,0,0,0,300.49,267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.52,278.63h0a.64.64,0,0,0-.62,0l-7,3.16a.83.83,0,0,1-1.16-.54,15.06,15.06,0,0,0-1-2.46L335,276.4a.68.68,0,0,1,.61,0h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,288.29v-9.08a.59.59,0,0,0-.9-.58l-7,3.16a.84.84,0,0,1-1.17-.54,15.75,15.75,0,0,0-1.56-3.47,1.93,1.93,0,0,1-.1-1.69l4.66-9.41a1.05,1.05,0,0,0-.42-1.36l-5.06-2.93a1.06,1.06,0,0,0-1.39.33l-5.81,8.74a1.91,1.91,0,0,1-1.52.75,15.72,15.72,0,0,0-3.78.39.83.83,0,0,1-1.05-.74l-.77-7.64a.59.59,0,0,0-.95-.48l-7.85,4.54a2.11,2.11,0,0,0-.94,1.46l-.79,8.75a2.93,2.93,0,0,1-.82,1.63,46.76,46.76,0,0,0-4.36,4.62,1.5,1.5,0,0,1-1.55.44l-5-1.76a1.23,1.23,0,0,0-1.42.52l-5.77,10a1.22,1.22,0,0,0,.25,1.49l4.05,3.49a1.49,1.49,0,0,1,.39,1.55,48.65,48.65,0,0,0-1.82,6.1,2.91,2.91,0,0,1-1,1.52l-7.17,5a2.11,2.11,0,0,0-.81,1.55v9.07a.59.59,0,0,0,.9.58l7-3.15a.83.83,0,0,1,1.17.54A15.22,15.22,0,0,0,289,325.2a2,2,0,0,1,.1,1.7l-4.66,9.4a1.07,1.07,0,0,0,.41,1.37l5.06,2.92a1.06,1.06,0,0,0,1.4-.33l5.81-8.73a2,2,0,0,1,1.52-.76,15.7,15.7,0,0,0,3.78-.38.83.83,0,0,1,1.05.74l.77,7.63a.59.59,0,0,0,.95.49l7.85-4.54a2.13,2.13,0,0,0,.94-1.47l.79-8.74a3,3,0,0,1,.82-1.64,46.83,46.83,0,0,0,4.36-4.62,1.51,1.51,0,0,1,1.54-.43l5.05,1.76a1.24,1.24,0,0,0,1.42-.53l5.77-10a1.22,1.22,0,0,0-.25-1.48l-4.05-3.49a1.51,1.51,0,0,1-.39-1.56,48,48,0,0,0,1.82-6.09,2.91,2.91,0,0,1,1-1.52l7.18-5.06A2.09,2.09,0,0,0,339.8,288.29Zm-30.74,28.53c-7.33,4.24-13.27.8-13.27-7.66s5.94-18.76,13.27-23,13.28-.8,13.28,7.67S316.4,312.59,309.06,316.82Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.82,349.75h0a.64.64,0,0,0-.68.06L296.83,352a1,1,0,0,1-1.33-.3,7.11,7.11,0,0,0-.64-.79,1.64,1.64,0,0,1-.39-1.57l5.26-3.33-3.93-2.27h0a.76.76,0,0,0-.26-.11l-2.49-.56a1.36,1.36,0,0,0-1.41.66l-2.35,4.46a2.45,2.45,0,0,1-1.41,1.07l-.15,0a5.31,5.31,0,0,0,.21-1L284,346h0a.62.62,0,0,0-.73.1L279.53,349a2.14,2.14,0,0,0-.71,1.59l.22,3.55a2.75,2.75,0,0,1-.58,1.72,28.19,28.19,0,0,0-1.73,2.3,1.92,1.92,0,0,1-1.52.77l-2.4-.12a1.53,1.53,0,0,0-1.38.85l-2.26,5.06a1,1,0,0,0,.39,1.21h0l2.66,1.53a1.25,1.25,0,0,1,.06.69,21.16,21.16,0,0,0-.42,2.42,3,3,0,0,1-.81,1.64l-3.31,3a2,2,0,0,0-.55,1.63l.62,3.61a.67.67,0,0,0,.3.49h0l3.95,2.28.05-4.52a1,1,0,0,1,1.33.3,6.36,6.36,0,0,0,.65.79,1.64,1.64,0,0,1,.38,1.58L272.78,386a.83.83,0,0,0,.33,1h0l3.95,2.28,1.07-2.94,1.52-3.78a2.48,2.48,0,0,1,1.42-1.07,10.9,10.9,0,0,0,1.53-.5.84.84,0,0,1,1.18.53l.85,2.8a.69.69,0,0,0,.32.44h0l4,2.28-.7-4.37,1.21-.95a2.07,2.07,0,0,0,.71-1.59l-.22-3.55a2.83,2.83,0,0,1,.58-1.72c.61-.73,1.54-1.12,2.08-1.92.31-.45.64-1.17,1.18-1.15l2.4.12a1.54,1.54,0,0,0,1.38-.84l2.25-5.07a1,1,0,0,0-.5-1.28l-1.94-.82a1.2,1.2,0,0,1-.66-1.34,23.08,23.08,0,0,0,.41-2.42,3,3,0,0,1,.81-1.64l3.31-3a2,2,0,0,0,.55-1.13l3-2.34Zm-15,23.35c-4,3.18-7.92,2.31-8.65-1.94s2.58-9.66,6.63-12.84,7.3-2.94,8,1.31S289.84,369.91,285.79,373.1Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.82,349.75h0a.64.64,0,0,0-.68.06L296.83,352a1,1,0,0,1-1.33-.3,7.11,7.11,0,0,0-.64-.79,1.64,1.64,0,0,1-.39-1.57l5.26-3.33-3.93-2.27h0a.76.76,0,0,0-.26-.11l-2.49-.56a1.36,1.36,0,0,0-1.41.66l-2.35,4.46a2.45,2.45,0,0,1-1.41,1.07l-.15,0a5.31,5.31,0,0,0,.21-1L284,346h0a.62.62,0,0,0-.73.1L279.53,349a2.14,2.14,0,0,0-.71,1.59l.22,3.55a2.75,2.75,0,0,1-.58,1.72,28.19,28.19,0,0,0-1.73,2.3,1.92,1.92,0,0,1-1.52.77l-2.4-.12a1.53,1.53,0,0,0-1.38.85l-2.26,5.06a1,1,0,0,0,.39,1.21h0l2.66,1.53a1.25,1.25,0,0,1,.06.69,21.16,21.16,0,0,0-.42,2.42,3,3,0,0,1-.81,1.64l-3.31,3a2,2,0,0,0-.55,1.63l.62,3.61a.67.67,0,0,0,.3.49h0l3.95,2.28.05-4.52a1,1,0,0,1,1.33.3,6.36,6.36,0,0,0,.65.79,1.64,1.64,0,0,1,.38,1.58L272.78,386a.83.83,0,0,0,.33,1h0l3.95,2.28,1.07-2.94,1.52-3.78a2.48,2.48,0,0,1,1.42-1.07,10.9,10.9,0,0,0,1.53-.5.84.84,0,0,1,1.18.53l.85,2.8a.69.69,0,0,0,.32.44h0l4,2.28-.7-4.37,1.21-.95a2.07,2.07,0,0,0,.71-1.59l-.22-3.55a2.83,2.83,0,0,1,.58-1.72c.61-.73,1.54-1.12,2.08-1.92.31-.45.64-1.17,1.18-1.15l2.4.12a1.54,1.54,0,0,0,1.38-.84l2.25-5.07a1,1,0,0,0-.5-1.28l-1.94-.82a1.2,1.2,0,0,1-.66-1.34,23.08,23.08,0,0,0,.41-2.42,3,3,0,0,1,.81-1.64l3.31-3a2,2,0,0,0,.55-1.13l3-2.34Zm-15,23.35c-4,3.18-7.92,2.31-8.65-1.94s2.58-9.66,6.63-12.84,7.3-2.94,8,1.31S289.84,369.91,285.79,373.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,372.29l-3.28,3a1.94,1.94,0,0,0-.5.94l4.86,2.81v-.26a1,1,0,0,1,1.33.3h0l4.68-2.71Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.36,363.18a17.46,17.46,0,0,1,1.2-1.66l-4.67-2.7a1.52,1.52,0,0,1-.68.15l-2.4-.12a1.54,1.54,0,0,0-1,.36l7.18,4.15Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.75,352a.66.66,0,0,0-.68.08l-3.31,2.18a1,1,0,0,1-1.32-.3,7.4,7.4,0,0,0-.65-.79,1.65,1.65,0,0,1-.39-1.58l.32-.84,1.42-.94a.64.64,0,0,1,.68-.06h0Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,351.05a1.71,1.71,0,0,0-.11-.14,1.64,1.64,0,0,1-.39-1.57l5.26-3.33-3.93-2.27h0a.76.76,0,0,0-.26-.11l-2.49-.56a1.36,1.36,0,0,0-1.41.66l-2.35,4.46a1.87,1.87,0,0,1-.53.6l5.29,3.06Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.92,350l4.86,2.81,4-3.66a6.71,6.71,0,0,0,.16-.9L284,346h0a.62.62,0,0,0-.73.1L279.53,349A2.05,2.05,0,0,0,278.92,350Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271,372.29l-3.28,3a1.94,1.94,0,0,0-.5.94l4.86,2.81v-.26a1,1,0,0,1,1.33.3h0l4.68-2.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.36,363.18a17.46,17.46,0,0,1,1.2-1.66l-4.67-2.7a1.52,1.52,0,0,1-.68.15l-2.4-.12a1.54,1.54,0,0,0-1,.36l7.18,4.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.75,352a.66.66,0,0,0-.68.08l-3.31,2.18a1,1,0,0,1-1.32-.3,7.4,7.4,0,0,0-.65-.79,1.65,1.65,0,0,1-.39-1.58l.32-.84,1.42-.94a.64.64,0,0,1,.68-.06h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,351.05a1.71,1.71,0,0,0-.11-.14,1.64,1.64,0,0,1-.39-1.57l5.26-3.33-3.93-2.27h0a.76.76,0,0,0-.26-.11l-2.49-.56a1.36,1.36,0,0,0-1.41.66l-2.35,4.46a1.87,1.87,0,0,1-.53.6l5.29,3.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.92,350l4.86,2.81,4-3.66a6.71,6.71,0,0,0,.16-.9L284,346h0a.62.62,0,0,0-.73.1L279.53,349A2.05,2.05,0,0,0,278.92,350Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.68,356.13l-.62-3.61a.6.6,0,0,0-1-.43l-3.31,2.18a1,1,0,0,1-1.32-.3,7.19,7.19,0,0,0-.65-.79,1.66,1.66,0,0,1-.39-1.57l1.69-4.57a.83.83,0,0,0-.62-1.13l-2.49-.56a1.34,1.34,0,0,0-1.41.66l-2.34,4.46a2.54,2.54,0,0,1-1.42,1.07,11.09,11.09,0,0,0-1.54.51.84.84,0,0,1-1.17-.54l-.85-2.8a.62.62,0,0,0-1.05-.33l-3.74,2.93a2.14,2.14,0,0,0-.71,1.59l.23,3.55a2.87,2.87,0,0,1-.58,1.72,26.17,26.17,0,0,0-1.74,2.3,2,2,0,0,1-1.52.77l-2.4-.12a1.53,1.53,0,0,0-1.38.85L273.1,367a1,1,0,0,0,.51,1.28l1.94.83a1.2,1.2,0,0,1,.66,1.33,23.53,23.53,0,0,0-.41,2.42,3.07,3.07,0,0,1-.81,1.64l-3.31,3a2,2,0,0,0-.56,1.63l.62,3.61a.6.6,0,0,0,1,.43l3.31-2.18a1,1,0,0,1,1.32.3,6.36,6.36,0,0,0,.65.79,1.67,1.67,0,0,1,.39,1.58l-1.69,4.56a.83.83,0,0,0,.62,1.13l2.49.56a1.34,1.34,0,0,0,1.41-.66l2.34-4.46a2.54,2.54,0,0,1,1.42-1.07,12.51,12.51,0,0,0,1.54-.5.84.84,0,0,1,1.17.53l.85,2.8a.62.62,0,0,0,1.05.33l3.74-2.93a2.14,2.14,0,0,0,.71-1.59l-.23-3.55a2.87,2.87,0,0,1,.58-1.72,26.17,26.17,0,0,0,1.74-2.3,2,2,0,0,1,1.52-.77l2.4.12a1.53,1.53,0,0,0,1.38-.85l2.26-5.06a1,1,0,0,0-.51-1.28l-1.94-.83a1.2,1.2,0,0,1-.66-1.33,23.53,23.53,0,0,0,.41-2.42,3.11,3.11,0,0,1,.81-1.64l3.31-3A2,2,0,0,0,305.68,356.13Zm-15.95,19.23c-4.05,3.19-7.93,2.32-8.66-1.93s2-10.28,6-13.46,7.93-2.32,8.66,1.93S293.77,372.18,289.73,375.36Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,343.13l-3.87-2.23h0a.69.69,0,0,0-.61,0l-7,3.15a.82.82,0,0,1-1.16-.53,15.54,15.54,0,0,0-1.56-3.47,2,2,0,0,1-.11-1.7L259,329a1.06,1.06,0,0,0-.42-1.37l-5.06-2.92a1.06,1.06,0,0,0-1.39.33l-5.81,8.74a1.91,1.91,0,0,1-1.52.75,14,14,0,0,0-2,.1V328.2L238.92,326h0a.65.65,0,0,0-.64.06l-7.86,4.53a2.08,2.08,0,0,0-.93,1.47l-.79,8.74a3,3,0,0,1-.82,1.64,46.76,46.76,0,0,0-4.36,4.62,1.53,1.53,0,0,1-1.55.44l-5-1.77a1.25,1.25,0,0,0-1.42.53l-5.78,10a1.24,1.24,0,0,0,.26,1.49l4,3.48a1.53,1.53,0,0,1,.4,1.56,46.44,46.44,0,0,0-1.82,6.09,2.94,2.94,0,0,1-1,1.53l-7.18,5.05a2.12,2.12,0,0,0-.8,1.54v9.08a.64.64,0,0,0,.28.58h0l3.87,2.24,5.75-2.73c.22.47.46.92.71,1.34a1.92,1.92,0,0,1,.11,1.7l-4.66,9.4a1.06,1.06,0,0,0,.41,1.37l5.06,2.92a1.06,1.06,0,0,0,1.39-.33l5.81-8.74a1.92,1.92,0,0,1,1.53-.75,15.77,15.77,0,0,0,3.78-.39.84.84,0,0,1,1.05.74l.77,7.64a.63.63,0,0,0,.3.53h0l3.86,2.23,4.64-6.81a2.15,2.15,0,0,0,.94-1.47l.79-8.75a1.72,1.72,0,0,1,1-1.32,18.42,18.42,0,0,0,6.11-4.28,1.56,1.56,0,0,1,1.56-.42l3.1,1.09a1.22,1.22,0,0,0,1.41-.52l5.78-10a1.23,1.23,0,0,0-.25-1.49l-2.66-2.29a1.62,1.62,0,0,1-.43-1.57,26.49,26.49,0,0,0,.72-7.25,2,2,0,0,1,.75-1.55l7.18-5.05a2.12,2.12,0,0,0,.8-1.55l3.43-4.11Zm-34.32,36c-7.33,4.23-11.89,1.23-11.89-7.24s6.06-18.84,13.39-23.07,11.78-1.15,11.78,7.31S241.68,374.87,234.35,379.1Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,343.13l-3.87-2.23h0a.69.69,0,0,0-.61,0l-7,3.15a.82.82,0,0,1-1.16-.53,15.54,15.54,0,0,0-1.56-3.47,2,2,0,0,1-.11-1.7L259,329a1.06,1.06,0,0,0-.42-1.37l-5.06-2.92a1.06,1.06,0,0,0-1.39.33l-5.81,8.74a1.91,1.91,0,0,1-1.52.75,14,14,0,0,0-2,.1V328.2L238.92,326h0a.65.65,0,0,0-.64.06l-7.86,4.53a2.08,2.08,0,0,0-.93,1.47l-.79,8.74a3,3,0,0,1-.82,1.64,46.76,46.76,0,0,0-4.36,4.62,1.53,1.53,0,0,1-1.55.44l-5-1.77a1.25,1.25,0,0,0-1.42.53l-5.78,10a1.24,1.24,0,0,0,.26,1.49l4,3.48a1.53,1.53,0,0,1,.4,1.56,46.44,46.44,0,0,0-1.82,6.09,2.94,2.94,0,0,1-1,1.53l-7.18,5.05a2.12,2.12,0,0,0-.8,1.54v9.08a.64.64,0,0,0,.28.58h0l3.87,2.24,5.75-2.73c.22.47.46.92.71,1.34a1.92,1.92,0,0,1,.11,1.7l-4.66,9.4a1.06,1.06,0,0,0,.41,1.37l5.06,2.92a1.06,1.06,0,0,0,1.39-.33l5.81-8.74a1.92,1.92,0,0,1,1.53-.75,15.77,15.77,0,0,0,3.78-.39.84.84,0,0,1,1.05.74l.77,7.64a.63.63,0,0,0,.3.53h0l3.86,2.23,4.64-6.81a2.15,2.15,0,0,0,.94-1.47l.79-8.75a1.72,1.72,0,0,1,1-1.32,18.42,18.42,0,0,0,6.11-4.28,1.56,1.56,0,0,1,1.56-.42l3.1,1.09a1.22,1.22,0,0,0,1.41-.52l5.78-10a1.23,1.23,0,0,0-.25-1.49l-2.66-2.29a1.62,1.62,0,0,1-.43-1.57,26.49,26.49,0,0,0,.72-7.25,2,2,0,0,1,.75-1.55l7.18-5.05a2.12,2.12,0,0,0,.8-1.55l3.43-4.11Zm-34.32,36c-7.33,4.23-11.89,1.23-11.89-7.24s6.06-18.84,13.39-23.07,11.78-1.15,11.78,7.31S241.68,374.87,234.35,379.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.48,332.07,259,329a1.06,1.06,0,0,0-.42-1.37l-5.06-2.92a1.06,1.06,0,0,0-1.39.33l-5.81,8.74a1.39,1.39,0,0,1-.39.37l6.51,3.75Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.16,369.79a2.65,2.65,0,0,1-.56.59l-7.18,5.05a1.78,1.78,0,0,0-.47.54l4.38,2.53,9.53-5.42Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.52,345.64a1.22,1.22,0,0,0-1,.58l-5.78,10a1.21,1.21,0,0,0-.13.73l5,2.87,7.91-10.7Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,331.5l6.16,3.56,7-4V328.2L238.92,326h0a.65.65,0,0,0-.64.06l-7.86,4.53A2.12,2.12,0,0,0,229.64,331.5Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,343.13h0a.62.62,0,0,0-.62,0l-7,3.15a.84.84,0,0,1-1.17-.54,14.59,14.59,0,0,0-1-2.45l5.3-2.39a.69.69,0,0,1,.61,0h0Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.48,332.07,259,329a1.06,1.06,0,0,0-.42-1.37l-5.06-2.92a1.06,1.06,0,0,0-1.39.33l-5.81,8.74a1.39,1.39,0,0,1-.39.37l6.51,3.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.16,369.79a2.65,2.65,0,0,1-.56.59l-7.18,5.05a1.78,1.78,0,0,0-.47.54l4.38,2.53,9.53-5.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.52,345.64a1.22,1.22,0,0,0-1,.58l-5.78,10a1.21,1.21,0,0,0-.13.73l5,2.87,7.91-10.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,331.5l6.16,3.56,7-4V328.2L238.92,326h0a.65.65,0,0,0-.64.06l-7.86,4.53A2.12,2.12,0,0,0,229.64,331.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,343.13h0a.62.62,0,0,0-.62,0l-7,3.15a.84.84,0,0,1-1.17-.54,14.59,14.59,0,0,0-1-2.45l5.3-2.39a.69.69,0,0,1,.61,0h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269,352.79v-9.07a.59.59,0,0,0-.9-.58l-7,3.15a.83.83,0,0,1-1.17-.54,15.22,15.22,0,0,0-1.56-3.46,2,2,0,0,1-.1-1.7l4.66-9.4a1.06,1.06,0,0,0-.41-1.37l-5.06-2.92a1.06,1.06,0,0,0-1.4.33L250.21,336a2,2,0,0,1-1.52.76,15.75,15.75,0,0,0-3.78.38.83.83,0,0,1-1-.74l-.77-7.63a.58.58,0,0,0-.94-.49l-7.86,4.54a2.13,2.13,0,0,0-.94,1.47l-.79,8.74a3,3,0,0,1-.81,1.64,46.91,46.91,0,0,0-4.37,4.62,1.51,1.51,0,0,1-1.54.43l-5.05-1.76a1.24,1.24,0,0,0-1.42.53l-5.77,10a1.22,1.22,0,0,0,.25,1.48l4.05,3.49a1.51,1.51,0,0,1,.39,1.56,48,48,0,0,0-1.82,6.09,2.91,2.91,0,0,1-1,1.52l-7.18,5.06a2.08,2.08,0,0,0-.8,1.54v9.08a.59.59,0,0,0,.89.58l7-3.16a.84.84,0,0,1,1.17.54,15.75,15.75,0,0,0,1.56,3.47,1.92,1.92,0,0,1,.1,1.7l-4.66,9.4a1.05,1.05,0,0,0,.42,1.36L219,405.1a1.06,1.06,0,0,0,1.39-.33l5.81-8.74a1.91,1.91,0,0,1,1.52-.75,15.72,15.72,0,0,0,3.78-.39.83.83,0,0,1,1,.74l.77,7.64a.59.59,0,0,0,.95.48l7.86-4.54a2.09,2.09,0,0,0,.93-1.46l.79-8.75a2.93,2.93,0,0,1,.82-1.63,46.76,46.76,0,0,0,4.36-4.62,1.51,1.51,0,0,1,1.55-.44l5,1.76a1.23,1.23,0,0,0,1.42-.52l5.78-10a1.23,1.23,0,0,0-.26-1.49l-4.05-3.49a1.49,1.49,0,0,1-.39-1.55,47,47,0,0,0,1.82-6.1,2.91,2.91,0,0,1,1-1.52l7.18-5.05A2.14,2.14,0,0,0,269,352.79Zm-30.73,28.54c-7.34,4.23-13.28.8-13.28-7.67s5.94-18.76,13.28-23,13.27-.8,13.27,7.66S245.55,377.09,238.22,381.33Z",
    style: {
      fill: "#72BBF7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-girl--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.44,182.75h32.65V153.49a16.33,16.33,0,0,0-16.33-16.33h0a16.33,16.33,0,0,0-16.32,16.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--girl-arm--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.71,174.81l-23.37.9c-.81-.7-5.44-6.22-5.44-6.22s-12.7-1.63-12.77-1.17,12.49,13.91,13.73,15.26a3.75,3.75,0,0,0,3,1.45l21.39,1.34Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.34,280.15l-.7-.4a4.48,4.48,0,0,1-2-3.5V204.46a4.48,4.48,0,0,1,2-3.5l92.22-53.23a4.43,4.43,0,0,1,4,0l.69.4a4.44,4.44,0,0,1,2,3.49v71.8a4.43,4.43,0,0,1-2,3.49l-92.22,53.24A4.47,4.47,0,0,1,249.34,280.15Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59,151.3c-.14-1.05-1-1.43-2-.85L253.37,203.7a4.06,4.06,0,0,0-1.43,1.5l-4.72-2.73a4.16,4.16,0,0,1,1.43-1.51l92.21-53.23a4.43,4.43,0,0,1,4,0l.69.4A4.5,4.5,0,0,1,347.59,151.3Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,280.31a4.49,4.49,0,0,1-3.68-.16l-.71-.4a4.48,4.48,0,0,1-2-3.5V204.46a4,4,0,0,1,.59-2l4.72,2.73a4.18,4.18,0,0,0-.59,2V279C251.35,280.14,252.08,280.68,253,280.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.67,207.65l6.94-4c.5-.29.91-.06.91.53V212a2,2,0,0,1-.92,1.58l-6.92,3.91c-.51.29-.92,0-.92-.54v-7.68A2,2,0,0,1,260.67,207.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.71,212.44a.55.55,0,0,1-.6,0L264,210.84c-.29-.21-.25-.81.08-1.33s.83-.77,1.11-.55l1.5,1.13,4.15-8.92c.26-.56.75-.93,1.11-.84s.42.63.17,1.18l-4.74,10.18a1.71,1.71,0,0,1-.61.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.67,224.65l6.94-4c.5-.29.91,0,.91.53V229a2,2,0,0,1-.92,1.58l-6.92,3.92c-.51.28-.92,0-.92-.54v-7.69A2,2,0,0,1,260.67,224.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.71,229.43a.55.55,0,0,1-.6,0L264,227.84c-.29-.22-.25-.82.08-1.34s.83-.77,1.11-.55l1.5,1.13,4.15-8.92c.26-.56.75-.93,1.11-.83s.42.62.17,1.18l-4.74,10.18a1.68,1.68,0,0,1-.61.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.67,241.64l6.94-4c.5-.3.91-.06.91.52V246a2,2,0,0,1-.92,1.57l-6.92,3.92c-.51.29-.92.05-.92-.54v-7.69A2,2,0,0,1,260.67,241.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.71,246.42a.51.51,0,0,1-.6,0L264,244.83c-.29-.21-.25-.81.08-1.33s.83-.77,1.11-.56l1.5,1.13,4.15-8.92c.26-.55.75-.93,1.11-.83s.42.62.17,1.18l-4.74,10.18a1.71,1.71,0,0,1-.61.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.67,258.68l6.94-4c.5-.29.91,0,.91.53V263a2,2,0,0,1-.92,1.57l-6.92,3.92c-.51.29-.92.05-.92-.54v-7.69A2,2,0,0,1,260.67,258.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.71,263.46a.51.51,0,0,1-.6,0L264,261.87c-.29-.22-.25-.81.08-1.34s.83-.76,1.11-.55l1.5,1.13,4.15-8.92c.26-.55.75-.93,1.11-.83s.42.62.17,1.18l-4.74,10.18a1.68,1.68,0,0,1-.61.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,200.34c0,.94.82,1.23,1.83.65l26.37-15.23a3.7,3.7,0,0,0,1.83-2.76c0-.94-.82-1.24-1.83-.65l-26.37,15.22A3.71,3.71,0,0,0,277.1,200.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,206.06c0,.95.82,1.24,1.83.66l56.4-32.52a3.7,3.7,0,0,0,1.83-2.77c0-.94-.82-1.23-1.83-.65l-56.4,32.52A3.7,3.7,0,0,0,277.1,206.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,217c0,.94.82,1.24,1.83.65l26.37-15.22a3.71,3.71,0,0,0,1.83-2.77c0-.94-.82-1.23-1.83-.65L278.93,214.2A3.7,3.7,0,0,0,277.1,217Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,222.69c0,.94.82,1.23,1.83.65l56.4-32.52a3.7,3.7,0,0,0,1.83-2.76c0-.94-.82-1.24-1.83-.65l-56.4,32.51A3.71,3.71,0,0,0,277.1,222.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,234.64c0,1,.82,1.24,1.83.65l26.37-15.22a3.7,3.7,0,0,0,1.83-2.77c0-.94-.82-1.23-1.83-.65l-26.37,15.23A3.7,3.7,0,0,0,277.1,234.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,240.37c0,.94.82,1.23,1.83.65l56.4-32.52a3.7,3.7,0,0,0,1.83-2.76c0-.94-.82-1.24-1.83-.65l-56.4,32.52A3.7,3.7,0,0,0,277.1,240.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,252.32c0,1,.82,1.24,1.83.66l26.37-15.23a3.7,3.7,0,0,0,1.83-2.76c0-1-.82-1.24-1.83-.66l-26.37,15.23A3.7,3.7,0,0,0,277.1,252.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,258.05c0,.94.82,1.24,1.83.65l56.4-32.51a3.73,3.73,0,0,0,1.83-2.77c0-.94-.82-1.23-1.83-.65l-56.4,32.52A3.7,3.7,0,0,0,277.1,258.05Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.14,333.58A42.35,42.35,0,0,1,353,339a2.71,2.71,0,0,0-.86.89c-.29.61-.75,2.11,2,3.08a10.34,10.34,0,0,0,8.55-.82c2.27-1.43,2.38-4.39,4.52-6.08,1.59-1.25,3.58-1.57,4.86-3.2.9-1.14.66-2.66.2-4.53-.51-2.05-.75-3.6-1.42-3.44l.11.94c-.85,1.35-5.23,1.75-7.18.82A79.48,79.48,0,0,1,359.14,333.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,335.5v0a26.44,26.44,0,0,0,1.92-1.9,50.85,50.85,0,0,0,3.58-5.27,5.87,5.87,0,0,0,1-3.77c-.15-1.42-.54-5.05-.54-5.05l6.94-.49.81,6.81h0c.17,1.54-1.11,2.91-3.37,4.86s-5.13,6.49-7.17,7.63-3.51,1.1-4.38.51S355,337.75,357.22,335.5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.33,334.2v-1c-.41,1.23-2.32,6.5-5.21,9.14-2.3,2.1-5.44,4.52-6.24,6.86s4.37,3.25,6.52,2.87a13.26,13.26,0,0,0,7.49-4c1.24-1.52,2-3.32,2.91-4.52s2.92-2.53,3.4-3.91a8.85,8.85,0,0,0-.42-3.83c-.34-1.29-.71-2.71-1.15-2.59v.8a5.78,5.78,0,0,1-3.65,1.23C392.92,335.23,390.33,335,390.33,334.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,344.14c.72-.63,1.44-1.26,2.09-1.85,2-1.85,3.56-5,4.45-7.11a10.11,10.11,0,0,0,.76-3.84v-4.16h7.3V334h0v.18l0,0c-.36,1.52-3.7,5.55-5.61,8.18-1.27,1.76-3.7,4-6.59,4.39S381.25,346.22,383,344.14Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.18,220.8c5.66,12.35-.2,55.88-.2,55.88.17,2,2.46,5.95,3.31,14.77,1,10.43-1.58,36.61-1.58,36.61a7.92,7.92,0,0,1-7.38.3s-6.95-39.44-8.26-49.8c-1.14-9.05-3.33-30.32-3.33-30.32l-6.57,30.33a38.48,38.48,0,0,1,1.28,9c-.1,6.13-2.95,33-2.95,33s-2.54,1.48-7.32.78c0,0-4.61-35.27-4.47-43.49.07-4.4,2-51.24,2-51.24Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.74,248.24l-1.84-10.1s-7.77-1.61-11.29-4.93a20.14,20.14,0,0,0,9.19,6.11l2.06,8.84-3.73,26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379.42,138.16l.38-4.28a2.08,2.08,0,0,0-2.37,1.87A2.27,2.27,0,0,0,379.42,138.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.65,138.59l3.46-2.54a2.09,2.09,0,0,0-3-.54A2.27,2.27,0,0,0,379.65,138.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.25,175.12s8.33.73,9.5,1.25c-6,6.55,3.12,9.27,3.12,9.27l-6.23,22.28c3.74,5.71,6.12,10.12,7.53,15.74-4.2,7.4-27.81,8.43-36.47,2.91.76-10.33,2.44-17.73,1.88-20.84-2.95-12.67-2.84-15.35-2.46-18.25.76-5.66,6.38-10.6,9.59-12.67h3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.31,145.14c-1.76,1-3.93,5.46-3.72,14.74.18,7.86,2.73,9.8,4,10.36s3.75.22,6.15-.18v4.72s-3.32,3.85-3.11,6,4.79,2.67,7.89.56a25.27,25.27,0,0,0,5.72-6.24l-.06-10.85s1.41,1.38,3.81-.72c2-1.73,2.64-4.64,1.1-6.2a3.44,3.44,0,0,0-5.48,1.09c-.66,1.43-2.16,1.45-2.17-.18-.07-8.36-1.06-8.8-1.9-12.23C373.55,144.4,370,145,366.31,145.14Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.37,157.9a1,1,0,1,0,2,.1,1,1,0,1,0-2-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,164.57l-2.29.73a1.17,1.17,0,0,0,1.49.82A1.24,1.24,0,0,0,371.1,164.57Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,155.28l2-1.38a1.18,1.18,0,0,0-1.67-.35A1.29,1.29,0,0,0,363.42,155.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.25,155.6l-2-1.39a1.17,1.17,0,0,1,1.66-.34A1.29,1.29,0,0,1,374.25,155.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.72,157.19a1,1,0,1,0,1-1A1,1,0,0,0,363.72,157.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.39 156.62 368.23 162.57 365.1 161.6 368.39 156.62",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.75,170.06c2.53-.33,7.73-1.82,8.54-3.88a5.3,5.3,0,0,1-1.83,2.62c-1.55,1.34-6.71,2.84-6.71,2.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.52,138.25h0A13.71,13.71,0,0,0,357.81,152v1.77h6.71a6.23,6.23,0,0,0,6.18-5.4h0l.25,5.4h0a5,5,0,0,0,4.94-4.53l.08-.88h0a5.88,5.88,0,0,0,5.86,5.41h.6l.68-9.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29,180c-1.86,2.76-12.47,26-12.47,26s-16-1.08-22.76-1.8c-2.13-.23-1.66-2.51-2.51-4.77s-1.94-1.82-1.94-1.82v3c.07,2-3.28,3.12-4.72,3.68-2.36.92-4.95,1.5-7.39,2.26a3.58,3.58,0,0,0-2.16,1.32,2.29,2.29,0,0,0,.07,2.24,7.09,7.09,0,0,0,5.48,3.35c2.72.33,5.36-.45,8-.93,3.13-.55,5.52-1,8.62-.59s6.86,1.22,9.81,1.76a101.12,101.12,0,0,0,11.43,1.32c2.13.1,3.68-.32,5.52-2.92s12-23.53,12-23.53c4.23-6,1.8-11.08-1.34-12.15C391,175.78,389.16,177.28,387.29,180Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.72,157.64a11.87,11.87,0,0,1,2.37.57,9.19,9.19,0,0,1,4.78,3.75,4.8,4.8,0,0,1,.59,2.85,2.06,2.06,0,0,1-.23.74,2.66,2.66,0,0,1-1.11.9,4.36,4.36,0,0,1-4.81.08,33.41,33.41,0,0,0-6.16-2.78,13.54,13.54,0,0,0-3.33-.59,3,3,0,0,0-1.79.65,2.61,2.61,0,0,1,.45-2.68,8.61,8.61,0,0,1,4.45-3.13A10.93,10.93,0,0,1,322.72,157.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-37"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.81,
    cy: 216.03,
    r: 10.49,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.71,
    y: 393.45,
    width: 7.39,
    height: 12.64,
    transform: "translate(248.8 799.54) rotate(180)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.31 392.77 153.69 393.02 154.06 379.64 146.31 379.39 146.31 392.77",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19,285.08c0,7.05-.91,57.93-.91,57.93-.17,2-2.08,5.77-1.66,13.57.55,10.59,1.77,43.19,1.77,43.19a9.72,9.72,0,0,0,8.22.16s6.52-43.31,7.84-53.81c1.16-9.15,3.12-34,3.12-34l4,29.89a41.94,41.94,0,0,0-.91,11.74c.34,4.85,3.19,34.91,3.19,34.91a10.05,10.05,0,0,0,8.52.65s3.74-42.84,3.82-47.3c.1-5.07-2.46-56.9-2.46-56.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.72,242.15c4.33,3.56,12.15,10.79,12.15,10.79l-12.2,6.71-7.76-20.81S150,238.24,154.72,242.15Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.72,242.15c4.33,3.56,12.15,10.79,12.15,10.79l-12.2,6.71-7.76-20.81S150,238.24,154.72,242.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,243.91s-2.76,2.77-2.76,9.47v14.47l-.21,27.33c10.6,5.59,24,5.91,35.29-2.35,0,0-.54-35.12-.54-40.88s-3.2-13.23-12-13.74l-11.39,2.65Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69,223.48s1.7,8,2.38,9.3a3.6,3.6,0,0,0,2.09,1.68l-.12-5.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.82,212.05a3.9,3.9,0,0,0-3.25,1.14c-1.4,1.43-.62,5.91,1.12,10.29l3.2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85,223.85c-.64.39-1.56-.85-2.35-1.67s-3.37-2-4.66.75S126,229.36,128,230c3.5,1.1,4-1.14,4-1.14l.27,12.64s3,5,10.79,6.2c4,.62,4.94-3.24.61-6.53v-3.85a22.17,22.17,0,0,0,4.73.24c2.58-.4,4.2-2.43,5-5.22,1.26-4.48,1.73-8.1.67-16.92-1.17-9.66-12.41-9.76-18.48-5.94S131.85,223.85,131.85,223.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.85,224.93c-.32,0-1.55-2-2.35-2.75-1.11-1,.32-10.13.32-10.13a4.34,4.34,0,0,1,1.07-4.62c1.52-1.66,4.05-1.85,8.38-2.53,2.27-.36,5.71-1,8-1.41,2.7-.51,4.94-1,6.86.62a4.82,4.82,0,0,1,1.32,5.38,4.63,4.63,0,0,1-.77,1.15,4.36,4.36,0,0,1-1.94,1.34s-1.18,1.05-5.29,1.55a60.59,60.59,0,0,1-11.38-.22c-1.19-.16-1.44,1-2.08,4.14C133.4,220.22,132.93,224.91,131.85,224.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.83,212.76,126,210.67a2.14,2.14,0,0,1,2.94-1A2.32,2.32,0,0,1,129.83,212.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7,237.31s-5.75-1.16-7.76-2.23a6.62,6.62,0,0,1-2.78-2.75,8.94,8.94,0,0,0,1.58,3.24c1.47,1.88,9,3.27,9,3.27Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,222.41a1.16,1.16,0,1,1-1.15-1.2A1.17,1.17,0,0,1,142.32,222.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1,218.06l-2.47,1.36a1.47,1.47,0,0,1,.57-2A1.38,1.38,0,0,1,141.1,218.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.18,230.38l2.63,1a1.38,1.38,0,0,1-1.78.87A1.47,1.47,0,0,1,143.18,230.38Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,219l-2.25-1.73a1.36,1.36,0,0,1,2-.3A1.49,1.49,0,0,1,152.6,219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.91,222.09a1.16,1.16,0,1,1-1.15-1.21A1.19,1.19,0,0,1,151.91,222.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.04 220.99 146.41 227.93 150.03 226.69 146.04 220.99",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.09,402.44v-1.05c.71.31,2.35,6.57,5.28,9.24,2.33,2.13,5.51,4.58,6.32,6.95s-4.43,3.82-6.61,3.44c-2.52-.45-6.91-2.23-8-3.88s-1.61-4.09-2.51-5.3-3-2.56-3.44-4a8.9,8.9,0,0,1,.43-3.87c.34-1.31.71-2.74,1.16-2.62v.8a5.77,5.77,0,0,0,3.69,1.25C125.48,403.48,128.1,403.27,128.09,402.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.77,390.75c.39,0,.7.55,1.54,1.47a16.3,16.3,0,0,0,4.35,3.12c2.76,1.39,8.14,3.52,10.57,4.61,1.53.69,1.45,2.53-.12,3.57s-5.36,1.8-9.92.78c-2.48-.56-5.71-2.85-7.76-2.72s-5.87.09-7.38-.95-.9-3.26-.47-5.17c.46-2.09,1-5.33,1.73-5.19V391c.89,1.34,5.47,1.89,7.42.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,312.09a27.44,27.44,0,0,0,10.28-5.9s-2,3.72-7.88,7.17l1.26,26.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,340.07l-.7-.4a4.49,4.49,0,0,1-2-3.5V264.38a4.49,4.49,0,0,1,2-3.5L210.26,225a4.47,4.47,0,0,1,4,0l.7.41a4.45,4.45,0,0,1,2,3.49v71.8a4.47,4.47,0,0,1-2,3.49l-62.18,35.9A4.47,4.47,0,0,1,148.78,340.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.73,254.26c10.77-6.22,19.51-1.17,19.51,11.27s-8.74,27.57-19.51,33.79-19.52,1.18-19.52-11.26S172,260.49,182.73,254.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59,264.06c3.49-2,6.33-.39,6.33,3.65a14,14,0,0,1-6.33,11c-3.5,2-6.33.39-6.33-3.65A14,14,0,0,1,182.59,264.06Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.06,285.58c0-6.63-4.65-9.32-10.4-6l-3.59,2.07c-5.74,3.32-10.4,11.38-10.4,18v1.79c3.32,1.1,7.5.5,12.06-2.13a38.42,38.42,0,0,0,12.33-12.2Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,228.56c-.14-1.05-1-1.43-2-.85l-62.18,35.91a4.14,4.14,0,0,0-1.43,1.5l-4.72-2.73a4.16,4.16,0,0,1,1.43-1.51L210.26,225a4.41,4.41,0,0,1,4,0l.7.4A4.54,4.54,0,0,1,217,228.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,340.23a4.51,4.51,0,0,1-3.69-.16l-.71-.4a4.49,4.49,0,0,1-2-3.5V264.38a4,4,0,0,1,.59-2l4.72,2.73a4.18,4.18,0,0,0-.59,2v71.81C150.79,340.06,151.52,340.6,152.47,340.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.28,322.17v0c0,2,1.43,2.87,3.2,1.85L201,303a7.06,7.06,0,0,0,3.2-5.54v0c0-2-1.43-2.87-3.2-1.85l-36.49,21.07A7.1,7.1,0,0,0,161.28,322.17Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.85,287.16c-3.79-2.64-3.74-6.56-2.53-11,8.25-30.5,10.78-30.67,14.38-32.21l2.89,12-7.71,25A48.71,48.71,0,0,0,136.13,289a7.2,7.2,0,0,0,3.85-.41c2.35-1.32,3.67-1.32,6.08-2v3.94a20.36,20.36,0,0,0,6.47-.22c5-.93,7.17.11,4.12,5.81-1.91,3.57-5.62,4.75-14.92,3.15a75.81,75.81,0,0,1-10-2.61A85.58,85.58,0,0,1,111.85,287.16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,243.91s3.55,2.23,4.31,7.82-4.62,20.8-4.62,20.8-8.69-.83-12.29-5.11c0,0,5-13.91,6-17.05A9.19,9.19,0,0,1,123.7,243.91Z",
    style: {
      fill: "#72BBF7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,243.91s3.55,2.23,4.31,7.82-4.62,20.8-4.62,20.8-8.69-.83-12.29-5.11c0,0,5-13.91,6-17.05A9.19,9.19,0,0,1,123.7,243.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,245.87v4.45s-2.4,3.65-5,5-2.56,6.74.65,7.5,7.63-3.21,8-5.39S220.23,245.64,217,245.87Z",
    style: {
      fill: "#ffa8a7"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupAmico);
export default __webpack_public_path__ + "static/media/Setup-amico.1f851d2d9c54a70233b7d34f9502205f.svg";
export { ForwardRef as ReactComponent };